module.exports = " <div> <div class=mdl-card__title> <h4 class=mdl-card__title-text>{{title}}</h4> </div> <div class=mdl-card__supporting-text> {{{text}}} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/segments/PaymentDetails.vue
// module id = 338
// module chunks = 0